namespace TabAurous.ECommerce {
    export namespace ECommOrderForStockAllocationService {
        export const baseUrl = 'ECommerce/ECommItemsForStockAllocation';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<ECommOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ECommerce/ECommItemsForStockAllocation/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>ECommOrderForStockAllocationService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
